<template>
        <div class="" v-if="item">
            <div class="row my-3">

              <div class="col col-md-12">
                  <div class="form-group required">
                    <label class='control-label'>Дата занятия</label>{{item.dateVisit}}
                    <date-component :disabled="isReadonly" v-model="item.dateVisit" :required="true" />
                  </div>
              </div>

              <div class="col col-md-12">
                <div class="form-group">
                  <label class='control-label pr-2'>Отметка о посещении</label>
                  <select v-model="item.markType" class="form-control">
                      <option value=""></option>
                      <option value="по QR-коду">по QR-коду</option>
                      <option value="по фотографии">по фотографии</option>
                  </select>
                </div>
              </div>

              <div class="col col-md-12">
                <div class="form-group">
                  <label class='control-label'>Вложение</label>
                  <file-upload width="100%" :entity="item"
                    @deleteFile="removeFile"
                    prop-name="file"
                    @uploaded="fileUploaded"/>
                </div>
              </div>

            <div class="col  col-md-12">
                <div class="form-group required">
                  <label class='control-label'>Промежуточные результаты	</label>
                  <div><textarea class="form-control" v-model="item.result" /></div>
                </div>
              </div>
            </div>

            <div class="">
              <div class="float-right d-flex align-items-center">
                <button-component class="btn btn-primary mx-2" v-if="!isReadonly" v-on:click="save">Сохранить</button-component>
                <button-component type="button" kind="secondary" class="btn btn-default" v-on:click="close">Закрыть</button-component>
              </div>
             </div>

        </div>
</template>
<script>
import API from '../api/imar'
import Constants from '../../../common/constants'
//import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import DateComponent from "@/common/components/DateComponent"
import moment from 'moment'
import FileUpload from "@/common/components/FileUpload";
import ButtonComponent from "../../../common/ui/ButtonComponent";

export default {
  name: "ImarVisitCard",
  components: {
    ButtonComponent,
    DateComponent,
    FileUpload
  },
  props: {
    journalImarId: Number,
    cardId:{
      type: Number,
      required: false,
      default: null
    },
    isReadonly:{
        type: Boolean,
        required: false,
        default: false
    }
  },
  created() {
    this.loadPage();
  },
  data() {
    return {
      item: {
        journalImarId: 0,
        file: null,
        dateVisit: moment().format("YYYY-MM-DD"),
        markType: '',
      },
    };
  },
  methods: {
    loadPage() {
        var self = this;
        if (self.cardId) {
          API.find(self.cardId).then(response => {
            self.item = response.data;
          });  
        } else {
            self.item.journalImarId = self.journalImarId;
        }       
    },
    save() {
        var self = this;

        self.v$.$touch();
        if (self.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error' );
          return;
        }

        API.saveVisit(self.item).then(function (response) {
            console.log(response.data);
            Constants.alert.fire('Сохранение', response.data.message, response.data.success ? 'success' : 'error' );
            if(response.data.success) {
                self.$emit('save');
            }
        });
    },    
    close() {
      this.$emit('close');
    },

    fileUploaded(e) {
        this.item.file = e.data;
    },
    removeFile() {
        this.item.file = null
    }
  },
  setup: () => ({ v$: useVuelidate() }),
  validations () {
    return {
      item: {
          //dateVisit: required
      }
    }
  }
}; 
</script>